// extracted by mini-css-extract-plugin
export default {"elements":"email-waiting-confirm_elements__CFpBN","helpTextEmail":"email-waiting-confirm_helpTextEmail__O2mCt"};